import { PartnerClientCompanyEventType, PartnerClientCompanyType, PartnerSupportLevel, defaults } from 'typed/api';
import { combineReducers, entityEditReducer, entityLoadAllReducer, switchReducers, synchronizableEnumReducer } from './utils';

const cs = defaults.NetworkArrayOf(defaults.PartnerClientCompanyReport);

export default combineReducers({
    partnerSupportLevels: synchronizableEnumReducer(defaults.NetworkArrayOf(defaults.PartnerSupportLevel), 'LOAD_ALL_PARTNER_SUPPORT_LEVELS', PartnerSupportLevel as any, 'PartnerSupportLevel'),
    partnerClientCompanyTypes: synchronizableEnumReducer(defaults.NetworkArrayOf(defaults.PartnerClientCompanyType), 'LOAD_ALL_PARTNER_CLIENT_COMPANY_TYPES', PartnerClientCompanyType as any, 'PartnerClientCompanyType'),
    partnerClientCompanyEventTypes: synchronizableEnumReducer(defaults.NetworkArrayOf(defaults.PartnerClientCompanyEventType), 'LOAD_ALL_PARTNER_CLIENT_COMPANY_EVENT_TYPES', PartnerClientCompanyEventType as any, 'PartnerClientCompanyEventType'),
    partnerClientCompanies: switchReducers(cs,
        entityLoadAllReducer(cs, 'LOAD_ALL_PARTNER_CLIENT_COMPANIES'),
        entityEditReducer(cs, 'EDIT_PARTNER_CLIENT_COMPANY')
    )
});


